import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { CdsForm, CdsTypeaheadField, CdsDateField } from 'clayco-component-library';

// Modal form for Household Items: single Move In Date (moveInDate) instead of start/end.
const HouseholdItemsModalForm = ({
  showModal,
  closeModal,
  editMode,
  isSubmitting,
  canSave,
  savePeriod,
  stayBenefitSchema,
  handleFormError,
  formData,
  setFormData,
  setIsDirty,
  fieldErrors,
  projectOptions,
  projectLoading,
  calculateDays
}) => (
  <Modal show={showModal} onHide={closeModal} backdrop="static" size="md">
    <CdsForm onSubmit={savePeriod} schema={stayBenefitSchema} onError={handleFormError}>
      <Modal.Header closeButton>
        <Modal.Title>{editMode ? 'Edit Household Items Request' : 'Add Household Items Request'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <CdsTypeaheadField
            key={`projectAssignment-${Array.isArray(formData.projectAssignment) && formData.projectAssignment[0]?.value ? formData.projectAssignment[0].value : 'none'}`}
            label="Project Assignment"
            name="projectAssignment"
            required
            options={projectOptions}
            selectedOptions={Array.isArray(formData.projectAssignment) ? formData.projectAssignment : []}
            isLoading={projectLoading}
            placeholder="Search or enter project assignment"
            allowMultiple={false}
            submitButton={false}
            onChange={(selected) => {
              const arr = Array.isArray(selected) ? selected : (selected ? [selected] : []);
              setFormData(prev => ({ ...prev, projectAssignment: arr }));
              setIsDirty(true);
            }}
          />
          {fieldErrors?.projectAssignment && <div className="text-danger small mt-1">{fieldErrors.projectAssignment}</div>}
        </div>
        <div className="mb-3">
          <CdsDateField
            label="Move In Date"
            name="moveInDate"
            required
            initialDate={formData.moveInDate ? new Date(formData.moveInDate + 'T00:00:00') : null}
            placeholder="MM/DD/YYYY"
            onChange={dateObj => {
              if (!(dateObj instanceof Date) || isNaN(dateObj)) return;
              const y = dateObj.getFullYear(), m = String(dateObj.getMonth() + 1).padStart(2, '0'), d = String(dateObj.getDate()).padStart(2, '0');
              setFormData(prev => ({ ...prev, moveInDate: `${y}-${m}-${d}` }));
              setIsDirty(true);
            }}
            onError={err => setFormData(prev => ({ ...prev, moveInDate: typeof err === 'string' ? err : err?.message }))}
          />
          {fieldErrors?.moveInDate && <div className="text-danger small mt-1">{fieldErrors.moveInDate}</div>}
        </div>
        {/* Single date only; min/max & duration logic removed. */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>Cancel</Button>
        <Button variant="primary" type="submit" disabled={isSubmitting || !canSave}>{isSubmitting ? 'Saving...' : 'Save'}</Button>
      </Modal.Footer>
    </CdsForm>
  </Modal>
);

export default HouseholdItemsModalForm;
